import React from "react";
import { Button, Input, Label, PopupForm } from "../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../common/others/Functions";
import OpacityLoading from "../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../store/reducers/authReducer";

const Login = ({ init }) => {
  const dispatch = useDispatch();
  const { todosLoading } = useSelector((state) => state.todosReducer);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const body = { ...data };
    dispatch(login(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>מס׳ נייד</Label>
        <Input
          {...register("phone", {
            required: true,
            pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
          })}
        />
        {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}

        <Label>סיסמא</Label>
        <Input
          type="text"
          {...register("password", {
            required: true,
            minLength: 2,
            maxLength: 20,
          })}
        />
        {CFV("password", "בין 2 ל 20 תווים", errors)}

        <Button style={{ width: "100%", margin: "10px auto" }}>התחברות</Button>
      </div>
      {todosLoading && <OpacityLoading />}
    </PopupForm>
  );
};

export default Login;
